import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles()(({ spacing }) => ({
  impersonationDialogTitle: {
    justifyContent: "center",
    paddingBottom: spacing(6)
  },
  impersonationDialogContent: {
    padding: spacing(0, 5, 3)
  },
  impersonationDialogText: {
    "& span": {
      fontWeight: 500
    }
  },
  impersonationDialogCancelButton: {
    fontWeight: 400
  }
}))
